/// <reference path="skyward.ui.workflowtemplate.js"/>
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.workflow = skyward.workflow || {};

        skyward.workflow.workflowList = {};

        var init = function ()
        {
            this.find(".workflow").each(function (index)
            {
                var workflow = $(this);
                var toolbar = workflow.find(".toolbar");
                var workflowContent = workflow.find(".workflowContent:first");
                var workflowConfirm = toolbar.find(".js-workflow__confirm");
                var workflowPrevious = toolbar.find(".js-workflow__previous");
                var workflowCancel = toolbar.find(".js-workflow__cancel");
                var workflowNewWindowButton = workflow.find(".js-workflowNewWindowButton");
                var workflowInstanceId = workflow.data("workflowInstanceId");
                var currentTaskInstanceIdWrapper = { currentTaskInstanceId: null };
                var hidden = 'hidden';
                var workflowPopup = workflow.parent('.workflowPopup');
                var workflowPopupId = workflowPopup.attr("id");
                var disableWorkflowNavigationPromiseCount = 0;

                skyward.workflow.addDisableNavigationPromise = function (promise)
                {
                    skyward.controls.toggle(toolbar.find(".button"), false);
                    disableWorkflowNavigationPromiseCount += 1;

                    promise = $.when(promise).always(() =>
                    {
                        disableWorkflowNavigationPromiseCount -= 1;
                        if (disableWorkflowNavigationPromiseCount === 0)
                        {
                            skyward.controls.toggle(toolbar.find(".button"), true);
                        }
                    });
                };

                if (skyward.global.mobileAccess)
                {
                    workflowNewWindowButton.hide();
                }
                else
                {
                    // Draggable
                    setNewWindowOnClick();

                    workflowPopup.draggable({
                        cancel: '.workflowHeader > a',
                        handle: '.workflowHeader',
                        scroll: false
                    });

                    skyward.modalLayer.setupDraggableLimits(workflowPopup);
                }

                // use a registerLoadDOMCallback to update the role=form attribute.
                // We can't rely on workflow-contentLoaded since other content can subsequently load, such as browses.
                skyward.window.registerLoadDOMCallback(() =>
                {
                    if (this === workflow[0])
                    {
                        setFormRoleOnWorkflowForAccessibility();
                    }
                });

                function setFormRoleOnWorkflowForAccessibility()
                {
                    const buttonsThatCanSave =
                        [
                            ".button .save",
                            ".button .saveAndForward",
                            ".button .update",
                            ".button .arrowRight",
                        ];
                    const hasSavingButtons = toolbar.find(buttonsThatCanSave.join(",")).filter(":visible").length > 0;
                    const hasInputControls = workflowContent.find(":input").not("[type=hidden]").length > 0;
                    const layerPseudoForm = workflow.closest(".layerPseudoForm");
                    if (!hasSavingButtons || !hasInputControls)
                    {
                        layerPseudoForm.removeAttr("role");
                        return;
                    }

                    const workflowTitleId = workflow.find(".workflowFriendlyName").addIds().attr("id");
                    layerPseudoForm.attr("aria-labelledby", workflowTitleId);
                    layerPseudoForm.attr("role", "form");
                }

                function setNewWindowOnClick()
                {
                    var url = window.location.pathname;
                    var urlArr;

                    if (!$.isEmptyObject(url))
                    {
                        urlArr = url.split('/');
                        if (urlArr.length <= 5)
                        {
                            urlArr[5] = null;
                        }
                    }

                    workflowNewWindowButton.on("click", function ()
                    {
                        skyward.window.loadContent('popout', urlArr[2], urlArr[3], urlArr[4] || "index", urlArr[5]);
                    });
                }

                // @MATTE: var moduleContentHeader used to be receiving the $ object below, but is never used aside from the .css() call, now chained.
                $("#currentPage label").css('display', 'inline-block');

                var previousButtonClicked = skyward.buttonManager.manageButtonClick(function ()
                {
                    var deferredClick = $.Deferred();

                    $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/partialcommit",
                        {
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                id: currentTaskInstanceIdWrapper.currentTaskInstanceId,
                                editableFields: skyward.controls.getEditableFields(workflowContent)
                            },
                            activityIndicator: { isWorkflowAjaxRequest: true },
                            success: function (data)
                            {
                                //Clear out any custom workflow buttons
                                workflow.find(".dirty.workflowButton").each(function ()
                                {
                                    $(this).remove();
                                });

                                if (data.previousTaskInstanceID)
                                {
                                    var target = skyward.workflow.getTopMostWorkflow().attr('id');
                                    skyward.buttonManager.waitForFunction(deferredClick, skyward.window.loadContent(target, "workflow", "taskinstance", "currentinstance", data.previousTaskInstanceID));
                                }
                                else
                                {
                                    callLoadContentFromUrl(data.redirectURL, undefined, data.redirectSettings);
                                    deferredClick.resolve();
                                }
                            },
                            error: function ()
                            {
                                deferredClick.resolve();
                            }
                        });

                    return deferredClick.promise();
                });

                var confirmButtonClicked = skyward.buttonManager.manageButtonClick(function ()
                {
                    return saveData(null);
                });

                var cancelButtonClicked = skyward.buttonManager.manageButtonClick(function ()
                {
                    var controls = skyward.controls.getOriginalValuesData("[data-workflow-task-instance-id='" + currentTaskInstanceIdWrapper.currentTaskInstanceId + "']");
                    $("[data-pending-task-instance='" + currentTaskInstanceIdWrapper.currentTaskInstanceId + "']").remove();
                    return $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/cancel/" + currentTaskInstanceIdWrapper.currentTaskInstanceId,
                        {
                            type: "POST",
                            data: controls,
                            activityIndicator: { hideGlass: true, isWorkflowAjaxRequest: true },
                            success: function (data)
                            {
                                skyward.workflow.closeWorkflowPopup();
                                $(document.body).trigger(data.cancelEventName);
                                if (data.redirectOnCancel)
                                {
                                    callLoadContentFromUrl(data.redirectURL, undefined, data.redirectSettings);
                                }
                            }
                        });
                });

                var customButtonClicked = skyward.buttonManager.manageButtonClick(function ()
                {
                    if ($(this).attr("data-prevent-task-completion") !== "true")
                    {
                        var skipGoingToNextTask = $(this).attr("data-go-to-next-task") === "false";
                        var taskInstanceRedirect = $(this).attr("data-task-instance-redirect") === "true";
                        var customButtonName = this.id.substr(this.id.indexOf("_") + 1); //split off the 'popup#_'
                        return customButtonAction(customButtonName, skipGoingToNextTask, taskInstanceRedirect);
                    }
                });

                skyward.workflow.customButtonAction = function (customButtonName)
                {
                    return customButtonAction(customButtonName);
                };

                var customButtonAction = function (name, skipGoingToNextTask, taskInstanceRedirect)
                {
                    var deferredClick = $.Deferred();

                    $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/setcustombuttonvariable/",
                        {
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                id: currentTaskInstanceIdWrapper.currentTaskInstanceId,
                                customButtonName: name
                            },
                            activityIndicator: { isWorkflowAjaxRequest: true },
                            success: function (returnData)
                            {
                                var data = {};
                                data[returnData.variableName] = returnData.variableValue;
                                skyward.buttonManager.waitForFunction(deferredClick, saveData(data, skipGoingToNextTask, taskInstanceRedirect));
                            },
                            error: function ()
                            {
                                deferredClick.resolve();
                            }
                        });

                    return deferredClick.promise();
                };

                var displayNextTask = function (data)
                {
                    data = data || {};
                    var target = workflowPopupId;
                    return skyward.window.loadContent(target, "workflow", "taskinstance", "currentinstance", data.taskInstanceId);
                };

                var endWorkflow = function (data, postponeRedirect)
                {
                    data = data || {};
                    $("[data-pending-task-instance='" + currentTaskInstanceIdWrapper.currentTaskInstanceId + "']").remove();
                    skyward.workflow.closeWorkflowPopup();

                    $(document.body).trigger(data.completeEventName, data);

                    var redirectFunction = null;

                    var control = data.updateControl ? getControlForUpdate(data) : undefined;
                    if ((control === undefined || control.length === 0) && (data.redirectURL || data.referrerURL || data.redirectTargetBlankURL))
                    {
                        var redirectFunction = function ()
                        {
                            if (data.redirectTargetBlankURL)
                            {
                                skyward.window.submitForm(data.redirectTargetBlankURL, data, { openNewWindow: true, actionVerb: "GET" });
                            }
                            else
                            {
                                callLoadContentFromUrl(data.redirectURL, data.referrerURL, data.redirectSettings);
                            }
                        };

                        if (postponeRedirect !== true)
                        {
                            redirectFunction();
                        }
                    }

                    if (data.updateControl)
                    {
                        var updateElement = $("#" + data.updateControl.pageStateControl);
                        if (data.popoutURL)
                        {
                            const path = data.popoutURL.split("/");
                            const pathData = path.length > 4 ? { tab: path[4] } : {};
                            skyward.window.loadContent("popout", path[0], path[1], path[2], data.updateControl.primaryKey, pathData);
                        }

                        var controlIsBrowse = skyward.browse.browseList[data.updateControl.pageStateControl] !== undefined;
                        var controlIsBrowseInDetailsPanel = skyward.browse.browseList["detailsPanel_" + data.updateControl.pageStateControl];

                        if (controlIsBrowse || controlIsBrowseInDetailsPanel)//i just created a new record to add to a browse
                        {
                            // This will run and update the browse's seek ID, even if we are in the process of redirecting, as long as the browse
                            // is on the page.
                            var browseId;
                            var browseData;
                            if (controlIsBrowse)
                            {
                                browseId = data.updateControl.pageStateControl;
                                browseData = {};
                                browseData.seekId = data.updateControl.primaryKey;
                                skyward.browse.get(browseId, browseData);
                                skyward.reference.reloadReferenceByControlId(browseId);
                            }

                            if (controlIsBrowseInDetailsPanel)
                            {
                                browseId = "detailsPanel_" + data.updateControl.pageStateControl;
                                browseData = {};
                                browseData.seekId = data.updateControl.primaryKey;
                                skyward.browse.get(browseId, browseData);
                                skyward.reference.reloadReferenceByControlId(browseId);
                            }
                        }
                        else if (updateElement.hasClass("ajaxRepeaterPlaceHolder"))
                        {
                            skyward.ajaxrepeater.load(updateElement);
                        }
                        else if (control && control.length > 0) //i need to update a control's value from my new object
                        {
                            var handled = control.triggerHandler("workflowEnd", data);
                            if (!handled)
                            {
                                // Legacy Code - Avoid Using - Prefer "workflowEnd" Event
                                updateControlWithValue(data, control);
                            }
                        }
                        else if (updateElement && updateElement.length > 0)
                        {
                            updateElement.triggerHandler("workflowEnd", data);
                        }
                    }

                    if (postponeRedirect === true)
                    {
                        return redirectFunction;
                    }
                };

                var getControlForUpdate = function (workflowData)
                {
                    var containersToCheck = [
                        "#moduleContent .toolContents",
                        "#moduleContent .contentArea",
                        "#moduleContent .dataObjectViewer",
                        "#detailsPanel .contentArea",
                        "#detailsPanel .dataObjectViewer",
                        ".filterBuilder"
                    ];
                    var popupId = skyward.window.getCurrentPopupId();
                    if (popupId >= 0)
                    {
                        containersToCheck.unshift("#popup" + popupId);
                    }

                    var control;
                    var container;

                    for (var i = 0; i < containersToCheck.length; i++)
                    {
                        container = $(containersToCheck[i]);
                        if (container.length)
                        {
                            control = container.find("[name='" + workflowData.updateControl.pageStateControl + "']");

                            if (control.length)
                            {
                                break;
                            }
                        }
                    }
                    return control;
                };

                var updateControlWithValue = function (workflowData, control)
                {
                    var pk = workflowData.updateControl.primaryKey;
                    var controlData = control.data();

                    var area = controlData.area;
                    var controller = controlData.controller;
                    var action = controlData.action;

                    var controlIsTileViewEEL = false;

                    var postData = {};
                    if (control)
                    {
                        postData["securityHash"] = controlData.securityHash;
                        if (control.hasClass('tileViewEEL_search'))
                        {
                            controlIsTileViewEEL = true;
                            area = controlData.updateControlAfterWorkflowArea;
                            controller = controlData.updateControlAfterWorkflowController;
                            action = controlData.updateControlAfterWorkflowAction;

                            postData = $.extend({}, postData, skyward.tilevieweel.getPostData(controlData, control));
                        }
                    }
                    $.ajax(
                        {
                            url: skyward.global.virtualDir + area + "/" + controller + "/" + action + "/" + pk,
                            type: "POST",
                            data: postData,
                            dataType: "JSON",
                            success: function (data)
                            {
                                if (controlIsTileViewEEL)
                                {
                                    skyward.tilevieweel.populateBoxes(control.parent().parent(), data, pk);
                                    return;
                                }

                                var eelValue = control.hasClass("codeEELValue") ? control : control.find(".codeEELValue");
                                var eelParent = eelValue.parent();
                                eelValue.val(pk);
                                if (controlData.action === "AccountDimensionEEL")
                                {
                                    skyward.accountDimensionEEL.populateBoxes(eelParent, data);
                                }
                                else
                                {
                                    skyward.codeeel.populateBoxes(eelParent, data, true);

                                    if (workflowData.redirectURL || workflowData.referrerURL)
                                    {
                                        callLoadContentFromUrl(workflowData.redirectURL, workflowData.referrerURL, workflowData.redirectSettings);
                                    }
                                }
                            }
                        });
                };

                var moveRefrenceAreaAboveWorkflowContent = function (dataContent, workflowContent)
                {
                    var dontMoveClassName = ".js-refArea--dont-move";
                    var contentReference = dataContent.find('.contentReference:not("' + dontMoveClassName + '"), .refArea:not("' + dontMoveClassName + '")');
                    if (contentReference.length)
                    {
                        contentReference.addClass("refArea--workflow").insertBefore(workflowContent);

                        //Since ref areas are added outside of workflowContent we need to call notifyDOMLoad on them directly.  This will no longer be necessary when skyward.ui.reference.ts is moved out of the bundle
                        if (contentReference.hasClass('contentReference'))
                        {
                            skyward.window.notifyDOMLoad("[data-workflow-instance-id='" + workflowInstanceId + "'] .contentReference");
                        }
                        if (contentReference.hasClass('refArea'))
                        {
                            skyward.window.notifyDOMLoad("[data-workflow-instance-id='" + workflowInstanceId + "'] .refArea");
                        }
                    }
                };

                var moveErrorsToTopOfWorkflowContent = function ()
                {
                    var errorList = workflow.find('#baseWorkflowErrorContainer');
                    if (errorList.length > 0)
                    {
                        errorList.parent().prepend(errorList);
                    }
                };

                var getPendingTaskInstance = function (TaskInstanceId, TaskInstanceDynamicPath)
                {
                    currentTaskInstanceIdWrapper.currentTaskInstanceId = TaskInstanceId;

                    // Even though we have it marked not to cache it is still being cached
                    // This is a temp work around until there is a solution. (Chrome issue)
                    // Does not seem to be an issue with IE or Firefox.
                    // http://bugs.jquery.com/ticket/12550
                    var time = (new Date()).getTime();
                    var url = "workflow/TaskInstance/DetailsContent/";

                    if (TaskInstanceDynamicPath)
                    {
                        url = TaskInstanceDynamicPath;
                    }

                    let workflowLoadingPromise = $.Deferred();
                    skyward.workflow.addDisableNavigationPromise(workflowLoadingPromise);

                    $.ajax(skyward.global.virtualDir + url + currentTaskInstanceIdWrapper.currentTaskInstanceId + "?renderType=contentOnly&blah=" + time,
                        {
                            type: "POST",
                            dataType: "viewpartHtml",
                            activityIndicator: { isWorkflowAjaxRequest: true },
                            // This is set to tell ContentMaster.sxl to show available bindings. These are also used in BaseController.cs to setup Field Restrictions.
                            data: { inWorkflow: true, currentTaskInstanceId: currentTaskInstanceIdWrapper.currentTaskInstanceId },
                            complete: function ()
                            {
                                workflowLoadingPromise.resolve();
                            },
                            success: function (data)
                            {
                                var dataContent = $('<div>').append(data);
                                moveRefrenceAreaAboveWorkflowContent(dataContent, workflowContent);
                                workflowContent.append(dataContent.children());
                                moveErrorsToTopOfWorkflowContent();
                                skyward.window.notifyDOMLoad("[data-workflow-instance-id='" + workflowInstanceId + "'] .workflowContent", { skywardContentPanel: true });

                                workflow.trigger("workflow-contentLoaded");

                                if (!skyward.global.mobileAccess)
                                {
                                    var layer = skyward.modalLayer.getLayerFromElement(workflowContent);
                                    if (layer)
                                    {
                                        var initialFocusElement = $(layer.options.initialFocusElement);
                                        if (!initialFocusElement.length || !layer.container.get(0).contains(initialFocusElement[0]))
                                        {
                                            // initialFocusElement doesn't exist or isn't in the current workflow step
                                            layer.options.initialFocusElement = workflowContent.find(":tabbable").first();
                                        }
                                        skyward.dialogFocusManager.setFocus(layer);
                                        initKeyboardClose(layer);
                                    }
                                }
                            }
                        });
                };


                var initKeyboardClose = function (layer)
                {
                    var origBeforeClose = layer.beforeClose;
                    layer.beforeClose = function ()
                    {
                        $(document).off("keydown", handleKeypress);
                        if (typeof origBeforeClose === "function")
                        {
                            return origBeforeClose.apply(null, arguments);
                        }
                    };

                    $(document).on("keydown", handleKeypress);

                    function handleKeypress(event)
                    {
                        var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
                        if (eventKeys.ESC && escapeShouldCloseWorkflow(layer))
                        {
                            skyward.modalLayer.showWarningDialog(
                                "close this Workflow",
                                "Any changes will not be saved.",
                                { onConfirm: cancelButtonClicked });
                        }
                    }

                    function escapeShouldCloseWorkflow(layer)
                    {
                        var isValidLayer = typeof layer === "object" && layer.container instanceof $ && layer.contents instanceof $;
                        if (isValidLayer)
                        {
                            var isLastOpenLayer = skyward.modalLayer.getOpenModalLayers().last().is(layer.container);
                            if (isLastOpenLayer)
                            {
                                var hasCancelButton = layer.contents.find(".js-workflow__cancel").not(".ui-disabled").length > 0;
                                if (hasCancelButton)
                                {
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                };

                skyward.workflow.getSavedData = function (savedData, workflowContent)
                {
                    savedData = savedData || {};

                    var localWorkflowContent = workflowContent;

                    localWorkflowContent.find("[name]:not(.doNotPost, .doNotPost *)").each(function ()
                    {
                        var element = $(this);
                        var elementName = element.attr("name");

                        if (elementName !== '')
                        {
                            var elementValue = skyward.controls.getValue(element);

                            if (elementValue instanceof Date)
                            {
                                if (skyward.datepicker.isValidDateObject(elementValue))
                                {
                                    elementValue = skyward.time.formatServerDate(elementValue, !element.hasClass("datepicker"));
                                }
                                else if (element.val().trim() === "")
                                {
                                    elementValue = "";
                                }
                                else
                                {
                                    elementValue = new Date(NaN);
                                }
                            }

                            if (!element.is(":radio") || elementValue) // Prevents radio buttons from overriding the selected one
                            {
                                savedData[elementName] = elementValue;
                            }
                        }
                    });

                    localWorkflowContent.find(".checkboxBrowse").each(function ()
                    {
                        var checkboxBrowse = $(this);
                        var browse = skyward.browse.browseList[checkboxBrowse.attr('id')];
                        savedData[browse.workflowVariableName] = JSON.stringify(
                            {
                                originalDefaultChecked: browse.originalDefaultChecked,
                                defaultChecked: browse.defaultChecked,
                                module: browse.browseModule,
                                object: browse.browseObject,
                                tempTableName: browse.tempTableName,
                                searchCondition: skyward.extensions.decodeHtml(browse.browseSearchCondition),
                                queryParameterData: browse.queryParameterData != null ? JSON.stringify(browse.queryParameterData) : undefined,
                                datas: skyward.checkboxbrowse.getSerializedOverriddenCheckboxDatas(browse)
                            });
                    });

                    localWorkflowContent.find(".editablebrowse").each(function ()
                    {
                        var editableBrowse = $(this);
                        var browseId = editableBrowse.attr("id");
                        var editabledata = skyward.editablebrowse.getEditableData(browseId);
                        savedData[browseId] = editabledata;
                    });

                    return savedData;
                };

                var saveData = function (buttonData, skipGoingToNextTask, taskInstanceRedirect)
                {
                    var originalValues = skyward.controls.getOriginalValuesData("[data-workflow-task-instance-id='" + currentTaskInstanceIdWrapper.currentTaskInstanceId + "']");
                    var savedData = skyward.workflow.getSavedData(buttonData, workflowContent);
                    var deferredClick = $.Deferred();

                    if (!skyward.dataobjectviewer.preSaveValidation(workflowContent))
                    {
                        return;
                    }

                    var warningHash = workflowContent.data("warninghash");
                    if (warningHash !== undefined && $.type(warningHash) !== "string")
                    {
                        warningHash = JSON.stringify(workflowContent.data("warninghash"));
                    }

                    $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/commit",
                        {
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                id: currentTaskInstanceIdWrapper.currentTaskInstanceId,
                                warninghash: warningHash,
                                warninghashes: JSON.stringify(workflowContent.data("warninghashes") || {}),
                                json: JSON.stringify(savedData),
                                controls: originalValues.controls,
                                editableFields: skyward.controls.getEditableFields(workflowContent),
                                workflowTemplateID: workflow.find(".js-workflowTemplateMenu-TemplateEEL").val()
                            },
                            activityIndicator: { isWorkflowAjaxRequest: true },
                            success: function (data)
                            {
                                switch (data.workflowStatus)
                                {
                                    case "F":
                                        // Invalid
                                        var baseWarningError = workflow.find("#baseWorkflowErrorContainer");
                                        skyward.validation.displayValidationMessages(data, workflowContent, baseWarningError);
                                        deferredClick.resolve();
                                        break;
                                    default:
                                        //InProgress (Or Completed, if it ever were to happen)
                                        workflowContent.data("workflowTaskInstanceId", "");

                                        if (taskInstanceRedirect && data.redirectURL)
                                        {
                                            skyward.buttonManager.waitForFunction(deferredClick, callLoadContentFromUrl(data.redirectURL));
                                        }
                                        else if (skipGoingToNextTask)
                                        {
                                            skyward.workflow.closeWorkflowPopup();
                                            window.location.reload();
                                        }
                                        else
                                        {
                                            skyward.buttonManager.waitForFunction(deferredClick, skyward.taskstatus.beginAsyncStatusReport(workflowInstanceId, endWorkflow, displayNextTask, null));
                                        }
                                        break;
                                }
                            },
                            error: function ()
                            {
                                deferredClick.resolve();
                            }
                        });
                    return deferredClick.promise();
                };

                var setScreenValues = function (valueData, skipWorkflowDefaultComboBoxes, resetEntryDefaults)
                {
                    for (var property in valueData)
                    {
                        if (skipWorkflowDefaultComboBoxes && property.indexOf('_DefaultComboBox') > -1)
                        {
                            continue;
                        }
                        if (valueData.hasOwnProperty(property))
                        {
                            var controlValue = valueData[property];
                            var element = $('[name="' + property + '"]');
                            if (controlValue instanceof Date)
                            {
                                controlValue = skyward.time.formatServerDate(controlValue, false);
                            }
                            if (resetEntryDefaults)
                            {
                                skyward.controls.setValue(element, null, false);
                            }
                            else
                            {
                                skyward.controls.setValue(element, controlValue, false);
                            }
                        }
                    }
                };

                skyward.workflow.getScreenValues = function (workflowContainer, buttonData)
                {
                    var warningHash = workflowContainer.data("warninghash");
                    if (warningHash !== undefined && $.type(warningHash) !== "string")
                    {
                        warningHash = JSON.stringify(workflowContainer.data("warninghash"));
                    }

                    var id = workflowContainer.data("workflow-task-instance-id");
                    var originalValues = skyward.controls.getOriginalValuesData("[data-workflow-task-instance-id='" + id + "']");

                    return {
                        id: id,
                        warninghash: warningHash,
                        warninghashes: JSON.stringify(workflowContainer.data("warninghashes") || {}),
                        json: JSON.stringify(skyward.workflow.getSavedData(buttonData, workflowContainer)),
                        controls: originalValues.controls,
                        editableFields: skyward.controls.getEditableFields(workflowContainer)
                    };
                };

                skyward.workflow.closeWorkflowPopup = function ()
                {
                    var topMostLayer = skyward.workflow.getTopMostWorkflow();

                    if (topMostLayer.length > 0)
                    {
                        var workflowId = topMostLayer.find(".workflow").data("workflow-instance-id");
                        delete skyward.workflow.workflowList[workflowId];
                        var layer = skyward.modalLayer.getLayerFromElement(topMostLayer);
                        if (layer)
                        {
                            skyward.window.popupList.shift(1);
                            layer.options.forceClose = true;
                            return layer.close();
                        }
                    }
                };

                skyward.workflow.callLoadContentFromUrl = function (workflowData)
                {
                    callLoadContentFromUrl(workflowData.redirectURL, workflowData.referrerURL, workflowData.loadContentSettings);
                };

                function callLoadContentFromUrl(redirectURL, referrerURL, loadContentSettings)
                {
                    if (!redirectURL && !referrerURL)
                    {
                        return $.Deferred().resolve().promise();
                    }

                    var url;

                    if (redirectURL === "")
                    {
                        url = referrerURL;

                        if (window.location.origin + skyward.global.virtualDir + url === window.location.href.replace(window.location.hash, ""))  //redirectURL was not set and we are attempting to reload the page we are on
                        {
                            return $.Deferred().resolve().promise();
                        }
                    }
                    else
                    {
                        url = redirectURL;
                    }

                    let data = null;

                    if (url.indexOf("?") > 0)
                    {
                        const paramUrl = url.substring(url.indexOf("?") + 1);
                        const urlParameters = new URLSearchParams(paramUrl);
                        urlParameters.delete("w");
                        urlParameters.delete("p");

                        if (urlParameters.size)
                        {
                            data = {};

                            urlParameters.forEach((value, key) =>
                            {
                                data[key] = value;
                            });
                        }

                        url = url.substring(0, url.indexOf("?")); //get rid of page state and window state params
                    }

                    var urlSegments = url.split("/"); //split on slashes
                    var area = urlSegments.length > 0 ? urlSegments[0] : null;
                    var controller = urlSegments.length > 1 ? urlSegments[1] : null;
                    var action = urlSegments.length > 2 ? urlSegments[2] : null;
                    var id = urlSegments.length > 3 ? urlSegments[3] : null;
                    var tab = urlSegments.length > 4 ? urlSegments[4] : null;

                    if (tab)
                    {
                        data = { ...data, tab: tab };
                    }

                    var target = "";
                    if (area.toLowerCase() === "workflow" && controller.toLowerCase() === "workflowinstance" && $("[data-workflow-instance-id='" + id + "']").length <= 0)//redirecting to another workflow, launch in a new popup
                    {
                        target = "popup";
                    }
                    else if ($(".workflowPopup").length <= 0) // All workflow tasks are completed
                    {
                        target = "full";
                    }
                    else//same workflow, new task
                    {
                        target = workflowPopupId;
                    }
                    var settingsObject = typeof loadContentSettings === "string" ? JSON.parse(loadContentSettings) : loadContentSettings;

                    return skyward.window.loadContent(target, area, controller, action, id, data, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, settingsObject);
                };

                toolbar.on("click", ".js-workflow__previous.dirty:not([ui-disabled])", null, previousButtonClicked)
                    .on("click", ".js-workflow__confirm.dirty:not([ui-disabled])", null, confirmButtonClicked)
                    .on("click", ".js-workflow__cancel", null, cancelButtonClicked)
                    .on("click", "a.workflowButton.dirty:not([ui-disabled])", null, customButtonClicked);

                skyward.changeTracking.setUpChangeTracking(workflowContent.filter(".js-changeTrackingRoot"));

                var loadPendingWorkflowAfterRefresh = function (instance)
                {
                    var taskInstanceId = instance.data("pendingTaskInstance");
                    var workflowInstance = instance.data("pendingWorkflowInstance");
                    if ($("[data-workflow-instance-id='" + workflowInstance + "']").length <= 0)
                    {
                        skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "CurrentInstance", workflowInstance,
                            undefined,
                            undefined,
                            undefined,
                            function ()
                            {
                                if ($("[data-workflow-task-instance-id='" + taskInstanceId + "']").length >= 0)
                                {
                                    pendingWorkflowData.taskInstanceId = taskInstanceId;
                                    displayNextTask(pendingWorkflowData);
                                }
                            },
                            undefined,
                            undefined,
                            function (layer)
                            {
                                skyward.window.closePopup(layer);
                                instance.remove();
                            });
                    }
                };

                // If we are returning to a previously started task, the task instance id is attached to the div of workflowContent
                var pendingTaskInstanceId = workflowContent.data("workflowTaskInstanceId");
                var pendingWorkflowInstances = $("#pendingWorkflows .instance");
                var pendingWorkflowData = {};

                if (pendingTaskInstanceId)
                {
                    getPendingTaskInstance(pendingTaskInstanceId, workflowContent.data("taskInstanceDynamicPath"));
                }
                else if (pendingWorkflowInstances.length > 0)
                {
                    for (var i = 0; i < pendingWorkflowInstances.length; i++)
                    {
                        var instance = $(pendingWorkflowInstances[i]);
                        loadPendingWorkflowAfterRefresh(instance);
                    }
                    pendingWorkflowInstances.remove();
                }
                else if (workflowInstanceId)
                {
                    skyward.taskstatus.beginAsyncStatusReport(workflowInstanceId, endWorkflow, displayNextTask, null);
                }

                if (workflowInstanceId !== undefined)
                {
                    skyward.workflow.workflowList[workflowInstanceId] =
                    {
                        "customButtonAction": customButtonAction,
                        "saveData": saveData
                    };
                }
            });
        };

        skyward.workflow.getPendingWorkflowInstances = function ()
        {
            var list = [];
            var workflowInstances = [];

            var pendingWorkflows = $("[data-workflow-instance-id]");

            pendingWorkflows.each(function ()
            {
                var workflow = $(this);
                var workflowInstanceId = workflow.attr("data-workflow-instance-id");
                var taskInstanceId = workflow.find(".workflowContent").attr("data-workflow-task-instance-id");

                if (workflowInstanceId && taskInstanceId)
                {
                    workflowInstances.push(
                        {
                            workflowInstanceId: workflowInstanceId,
                            taskInstanceId: taskInstanceId
                        });
                }
            });

            var data =
            {
                id: "pendingWorkflows",
                items: workflowInstances,
                skip: true
            };

            list.push(data);

            return list;
        };

        skyward.workflow.getTopMostWorkflow = function ()
        {
            return $(".modalLayerContainer .workflowPopup").last();
        };

        skyward.workflow.getTopMostWorkflowData = function ()
        {
            return skyward.workflow.getTopMostWorkflow().find(".workflow").data();
        }

        var primaryButtonPressed = function ()
        {
            var elem = $(this);
            skyward.browse.selectRowByElement(this);
            var workflowId = elem.closest(".workflow").data("workflow-instance-id");

            var data = elem.data();
            var workflow = skyward.workflow.workflowList[workflowId];

            if (data.workflowVariableValue !== undefined && data.workflowVariableToSet !== undefined)
            {
                var saveData = {};
                saveData[data.workflowVariableToSet] = data.workflowVariableValue;
                workflow.saveData(saveData);
            }
            else if (data.workflowCustomButtonName !== undefined)
            {
                workflow.customButtonAction(data.workflowCustomButtonName);
            }
        };

        var gatherDataForError = function ()
        {
            var workflows = $(".workflowPopup .workflow").toArray().map(function (workflowElem)
            {
                var workflow = $(workflowElem);
                var data = workflow.data();
                var workflowPopup = workflow.parent('.workflowPopup');
                var workflowPopupId = workflowPopup.attr("id");
                var name = workflow.find(".workflowFriendlyName").text();
                var description = workflow.find(".taskDescription").text();
                var workflowContentData = workflow.find(".workflowContent").data();
                return {
                    workflowInstanceId: data.workflowInstanceId,
                    popupId: workflowPopupId,
                    taskInstanceId: workflowContentData.taskInstanceId,
                    taskInstanceDynamicPath: workflowContentData.taskInstanceDynamicPath,
                    name: name,
                    description: description
                };
            });

            return {
                openWorkflows: workflows,
                pendingWorkflows: skyward.workflow.getPendingWorkflowInstances()[0].items,
            };
        };

        var events =
        {
            "primaryButtonPressed": primaryButtonPressed
        };

        skyward.events.registerEvents("workflow", events);
        skyward.error.registerErrorDataGatherer("workflow", gatherDataForError);

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
